import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartBreakIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6846 3.00098C12.5211 3.03272 14 4.53091 14 6.375C14 6.42141 13.9989 6.46764 13.9971 6.51367C13.9333 8.647 12.3787 10.2731 11.042 11.2979C10.3527 11.8262 9.67065 12.2337 9.16309 12.5088C8.90843 12.6468 8.69492 12.7531 8.54395 12.8252C8.49002 12.8509 8.44357 12.8716 8.40625 12.8887L9.70605 9.25195C9.80344 8.97905 9.73517 8.67463 9.53027 8.46973L7.97266 6.91211L10.6846 3.00098ZM5.375 3C6.43258 3 7.3763 3.48671 7.99512 4.24805L6.38379 6.57227C6.17716 6.8703 6.21329 7.27384 6.46973 7.53027L8.13379 9.19434L6.93164 12.5586C6.89607 12.5397 6.85868 12.5213 6.82129 12.501C6.30514 12.2205 5.61285 11.8044 4.91602 11.2656C3.56399 10.2203 1.9991 8.55808 1.99902 6.37988C1.99903 6.36715 1.99936 6.35445 2 6.3418C2.01791 4.49323 3.52222 3.00005 5.375 3Z",
		fill: "currentColor",
		stroke: "none"
	})
});
export default SvgHeartBreakIcon;
